var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "profile-share-container has-dy" }, [
    _c("div", { staticClass: "top" }, [
      _c(
        "div",
        { staticClass: "lft" },
        [
          _vm.isLite
            ? [
                _c("img", {
                  staticClass: "logo",
                  attrs: { src: require("../assets/micolite.png"), alt: "" },
                }),
                _vm._v(" "),
                _vm._m(0),
              ]
            : [
                _c("img", {
                  staticClass: "logo",
                  attrs: { src: require("../assets/mico.png"), alt: "" },
                }),
                _vm._v(" "),
                _vm._m(1),
              ],
        ],
        2
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "download", on: { click: _vm.linkToProfileByOneLink } },
        [_vm._v("\n      " + _vm._s(_vm.text[`key3`]) + "\n    ")]
      ),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "swiper-container" }, [
      _vm.profile.isLive
        ? _c("img", {
            staticClass: "live",
            attrs: { src: require("../assets/live.gif") },
            on: { click: _vm.linkToProfileByOneLink },
          })
        : _vm._e(),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "swiper-wrapper" },
        _vm._l(
          [_vm.profile?.avatar, ..._vm.profile?.photowall],
          function (item, index) {
            return _c("div", { key: index, staticClass: "swiper-slide" }, [
              index > 0
                ? _c("div", { staticClass: "bg bg-blur" }, [
                    _c(
                      "div",
                      {
                        staticClass: "download",
                        on: { click: _vm.linkToProfileByOneLink },
                      },
                      [
                        _vm._v(
                          "\n            " +
                            _vm._s(
                              _vm.isLite
                                ? _vm.text[`key5`]?.replace(
                                    /mico/i,
                                    "Mico Lite"
                                  )
                                : _vm.text[`key5`]
                            ) +
                            "\n          "
                        ),
                      ]
                    ),
                  ])
                : _vm._e(),
              _vm._v(" "),
              _c("img", {
                staticClass: "company-pic",
                attrs: {
                  src: `//thumbnail-large.${_vm.topDomain}/${item}`,
                  alt: "",
                  onerror:
                    "this.src = this.src.replace('thumbnail-large', 'image'); this.onerror = null;",
                },
              }),
            ])
          }
        ),
        0
      ),
      _vm._v(" "),
      [_vm.profile?.avatar, ..._vm.profile?.photowall].length > 1
        ? _c("div", { staticClass: "swiper-pagination" })
        : _vm._e(),
    ]),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "profile-content" },
      [
        _vm.profile?.audioIntro
          ? _c("audioComp", {
              attrs: {
                recordFile: `/pub/share/user/audio/${_vm.profile?.audioIntro}`,
              },
            })
          : _vm._e(),
        _vm._v(" "),
        _c("img", {
          staticClass: "avatar",
          attrs: {
            src: `//thumbnail-small.${_vm.topDomain}/${_vm.profile?.avatar}`,
            alt: "",
            onerror:
              "this.src = this.src.replace('thumbnail-small', 'image'); this.onerror = null;",
          },
          on: { click: _vm.linkToProfileByOneLink },
        }),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "p-t", on: { click: _vm.linkToProfileByOneLink } },
          [
            _c("div", { staticClass: "nickname" }, [
              _vm._v(_vm._s(_vm.profile?.displayName)),
            ]),
            _vm._v(" "),
            _c(
              "div",
              { class: `age ${_vm.profile?.gendar !== 1 ? `male` : `female`}` },
              [
                _c("img", {
                  attrs: {
                    src: require(`../assets/${
                      _vm.profile?.gendar !== 1 ? "male" : "female"
                    }.png`),
                    alt: "",
                  },
                }),
                _vm._v(" "),
                _c("span", [_vm._v(_vm._s(_vm.profile?.age))]),
              ]
            ),
          ]
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "id", on: { click: _vm.linkToProfileByOneLink } },
          [_vm._v("ID: " + _vm._s(_vm.profile?.userId))]
        ),
        _vm._v(" "),
        _c("div", { staticClass: "intro" }, [
          _vm._v(_vm._s(_vm.profile?.description)),
        ]),
      ],
      1
    ),
    _vm._v(" "),
    _c("div", { staticClass: "moment-container" }, [
      _c("div", { staticClass: "m-t" }, [_vm._v("Moments")]),
      _vm._v(" "),
      !_vm.profile.circle
        ? _c("div", { staticClass: "empty" }, [
            _c("img", {
              staticClass: "ic-empty",
              attrs: { src: require("../assets/ic_feed_null.png"), alt: "" },
            }),
            _vm._v(" "),
            _c("span", [_vm._v(_vm._s(_vm.text["key4"]))]),
          ])
        : _c("div", { staticClass: "moment-item" }, [
            _c(
              "div",
              {
                staticClass: "m-top",
                on: { click: _vm.linkToProfileByOneLink },
              },
              [
                _c("img", {
                  staticClass: "avatar",
                  attrs: {
                    src: `//thumbnail-small.${_vm.topDomain}/${_vm.profile?.avatar}`,
                    alt: "",
                  },
                }),
                _vm._v(" "),
                _c("div", { staticClass: "rht" }, [
                  _c("div", { staticClass: "nickname" }, [
                    _vm._v(_vm._s(_vm.profile?.displayName)),
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      class: `age ${
                        _vm.profile?.gendar !== 1 ? `male` : `female`
                      }`,
                    },
                    [
                      _c("img", {
                        attrs: {
                          src: require(`../assets/${
                            _vm.profile?.gendar !== 1 ? "male" : "female"
                          }.png`),
                          alt: "",
                        },
                      }),
                      _vm._v(" "),
                      _c("span", [_vm._v(_vm._s(_vm.profile?.age))]),
                    ]
                  ),
                ]),
              ]
            ),
            _vm._v(" "),
            _c("div", { staticClass: "m-bot" }, [
              _c("div", { staticClass: "dy-text" }, [
                _vm._v(_vm._s(_vm.profile?.circle?.text)),
              ]),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "img-box", style: { height: _vm.boxHeight } },
                _vm._l(_vm.filledSize, function (index) {
                  return _c(
                    "div",
                    {
                      key: index,
                      staticClass: "img-item",
                      style: { width: _vm.itemWidth, height: _vm.itemHeight },
                    },
                    [
                      _vm.profile?.circle?.fids?.[index - 1]
                        ? _c("img", {
                            staticClass: "dy-image",
                            attrs: {
                              src: `//thumbnail-${
                                _vm.filledSize <= 2 ? "large" : "middle"
                              }.${_vm.topDomain}/${
                                _vm.profile?.circle?.fids?.[index - 1]
                              }`,
                              alt: "",
                              onerror:
                                "this.src = this.src.replace(/thumbnail-(middle|large)/, 'image'); this.onerror = null;",
                            },
                          })
                        : _c("div", { staticClass: "dy-image" }),
                    ]
                  )
                }),
                0
              ),
            ]),
          ]),
    ]),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "fix-bot", on: { click: _vm.linkToProfileByOneLink } },
      [
        _c(
          "div",
          { staticClass: "link", on: { click: _vm.linkToProfileByOneLink } },
          [
            _c("span", [
              _vm._v(
                "\n          " +
                  _vm._s(
                    _vm.isLite
                      ? _vm.text[`key5`].replace(/mico/i, "Mico Lite")
                      : _vm.text[`key5`]
                  ) +
                  "\n        "
              ),
            ]),
            _vm._v(" "),
            _c("img", {
              staticClass: "ic-arrow",
              attrs: { src: require("../assets/ic_arrow.png"), alt: "" },
            }),
          ]
        ),
        _vm._v(" "),
        _vm._m(2),
      ]
    ),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "info" }, [
      _c("div", { staticClass: "t" }, [_vm._v("Mico Lite")]),
      _vm._v(" "),
      _c("div", { staticClass: "desc" }, [
        _vm._v("\n            Socialize in a video way\n          "),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "info" }, [
      _c("div", { staticClass: "t" }, [_vm._v("MICO")]),
      _vm._v(" "),
      _c("div", { staticClass: "desc" }, [
        _vm._v("\n            Socialize in a video way\n          "),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "btn-share" }, [
      _c("div", { staticClass: "like" }, [
        _c("img", {
          attrs: { src: require("../assets/ic_like.png"), alt: "" },
        }),
        _vm._v(" "),
        _c("div", { staticClass: "placeholder" }),
        _vm._v(" "),
        _c("span", [_vm._v("like")]),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "chat" }, [
        _c("img", {
          attrs: { src: require("../assets/ic_chat.png"), alt: "" },
        }),
        _vm._v(" "),
        _c("div", { staticClass: "placeholder" }),
        _vm._v(" "),
        _c("span", [_vm._v("Chat")]),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "follow" }, [
        _c("img", { attrs: { src: require("../assets/ic_add.png"), alt: "" } }),
        _vm._v(" "),
        _c("div", { staticClass: "placeholder" }),
        _vm._v(" "),
        _c("span", [_vm._v("Follow")]),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }